import { Line } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const feedLineDictionary = createSimpleDictionary([
    { id: Line.Main, name: 'dictionaries.feedLine.main' },
    { id: Line.Two, name: 'dictionaries.feedLine.two' },
    { id: Line.Three, name: 'dictionaries.feedLine.three' },
    { id: Line.Four, name: 'dictionaries.feedLine.four' },
    { id: Line.Five, name: 'dictionaries.feedLine.five' },
    { id: Line.All, name: 'dictionaries.feedLine.all' },
]);
